const carerinformation = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Carer Information",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    info_box: {
                      type: "checkbox",
                      label: "Add Information Box",
                      hideLabel: false,
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    carer_form: {
                      type: "toggle",
                      label: "Carer Form",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    template: {
                      type: "select",
                      label: "Template",
                      placeholder: "Select Template",
                      displayOn: "carer_form",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Template A", "Template B", "Template C"],
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    carer_documents: {
                      type: "toggle",
                      label: "Carer Documents",
                      placeholder: "Select Carer Documents",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    carer_documents_list: {
                      type: "variableList",
                      label: "Carer Documents List",
                      placeholder: "Select",
                      displayOn: "carer_documents",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                    carer_newsletters: {
                      type: "toggle",
                      label: "Carer Newsletters",
                      placeholder: "Select Carer Newsletters",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    carer_newsletters_list: {
                      type: "variableList",
                      label: "Carer Newsletters List",
                      placeholder: "Select",
                      required: false,
                      displayOn: "carer_newsletters",
                      displayOnValue: "true",
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  answer: "",
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    answer: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { carerinformation };
